<template>
  <v-app>
    <Sidebar class="seller-sidebar" @logout="handleLogout" />

    <v-main>
      <div class="seller-content" :class="{ 'seller-content--mobile': $vuetify.breakpoint.smAndDown }">
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from "@/components/SidebarSeller.vue";
import { logoutApi } from "@/services/api/auth";
import { getUnreadCountApi } from "@/services/api/notification";
import { getUnreadCountApi as getChatUnreadCountApi } from "@/services/api/chat";
import { getSellerOrderPendingCountApi } from "@/services/api/sellerServices";

export default {
  name: "DefaultSeller",
  components: { Sidebar },

  data() {
    return { pollInterval: null };
  },

  async created() {
    await this.fetchBadgeCounts();
    this.pollInterval = setInterval(this.fetchBadgeCounts, 30000);
  },

  beforeDestroy() {
    clearInterval(this.pollInterval);
  },

  methods: {
    async fetchBadgeCounts() {
      const [notif, chat, order] = await Promise.allSettled([
        getUnreadCountApi(),
        getChatUnreadCountApi("seller"),
        getSellerOrderPendingCountApi(),
      ]);
      this.$store.commit("SET_BADGE_COUNTS", {
        notif: notif.status === "fulfilled" ? (notif.value.count        || 0) : undefined,
        chat:  chat.status  === "fulfilled" ? (chat.value.unreadCount   || 0) : undefined,
        order: order.status === "fulfilled" ? (order.value.count        || 0) : undefined,
      });
    },

    async handleLogout() {
      try {
        await logoutApi().catch(() => {});
      } catch (e) {
        console.error("Logout error:", e);
      } finally {
        if (this.$store && this.$store.dispatch) {
          await this.$store
            .dispatch("logout", { authGroup: "seller" })
            .catch(() => {});
        }

        sessionStorage.clear();

        this.$router.replace({ name: "login_seller" }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.seller-content {
  min-height: 100vh;
  background: #f6f9ff;
  padding: 24px;
}

.seller-content--mobile {
  padding: 12px 12px calc(72px + env(safe-area-inset-bottom, 0px));
}
</style>
